import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Link, useLocation } from "react-router-dom"
import Card from "@material-ui/core/Card"
import CardHeader from "@material-ui/core/CardHeader"
import CardMedia from "@material-ui/core/CardMedia"
import CardContent from "@material-ui/core/CardContent"
import CardActions from "@material-ui/core/CardActions"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import { Divider, Grid, IconButton, Box } from "@material-ui/core"
import TextField from "@material-ui/core/TextField"
import { Field, ErrorMessage } from "formik"
import { PaginationDownSVG, PaginationUpSVG } from "../icons"
import {
	getFileRequestByPage,
	getFileRowClickRequest,
	getPageNumberBasedOnHighlightTextFailed,
	getPageNumberBasedOnHighlightTextRequest,
	resetPageViewerData,
} from "../../actions/documentModalActions"

import { useHistory } from "react-router-dom"
import _ from "lodash"
import {
	getAnnotation,
	getAuditHistory,
	getChat,
	getViewerAllDocumentsRequest,
	updateCurrentSession,
	updateSkipCount,
	updateViewerPageNumber,
} from "../../actions/viewerActions"
import { getReviewBasedOnFileIdRequest } from "../../actions/reviewActions"
import { getConceptBasedOnId, resetHighlightFilter, searchHighlightFilter } from "../../actions/highlightActions"
import { checkToShowNativeFormat } from "../../utils"
import { getInfo } from "../../actions/infoActions"

const useStyles = makeStyles((theme) => ({
	pagination: {
		flex: 2,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		padding: "5px",
		borderRight: `solid 1px ${theme.palette.grey.D400}`,
		"& .MuiInputBase-input": {
			padding: "5px 10px",
			marginRight: "10px",
			border: `solid 1px ${theme.palette.grey.D400}`,
		},
	},
}))

const ViewerDocumentNavigation = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const history = useHistory()
	const location = useLocation()
	const theme = useTheme()
	const [pageNumber, setPageNumber] = useState(1)
	const [currentIndex, setCurrentIndex] = useState(0)
	const [currentDocumentDirection, setCurrentDocumentDirection] = useState(null)
	const { documentDetails, pageNumberForCurrentDocument } = useSelector((state) => state.documentModal)
	const { allDocuments, allDocumentsCount, allDocumentsLoading } = useSelector((state) => state.viewerData)
	const highlightFilter = useSelector((state) => state.highlightFilter.search)
	const { currentPageNumber, skipCount } = useSelector((state) => state.viewerData)
	const aiEnabled = useSelector((state) => state?.info?.version?.ai_enabled)

	const getPageNumberBasedOnHighlightText = (fileId) => {
		const params = location?.pathname?.split("/")
		if (highlightFilter["specificWord"] || highlightFilter["concepts"]) {
			let searchText = highlightFilter["specificWord"] ? highlightFilter?.searchWord : []
			let selectedConcept = highlightFilter["concepts"] ? highlightFilter?.loadedConcept : []
			const payload = {
				categories: props?.retainedFilterJobData?.categories || [],
				text: [...searchText, ...selectedConcept],
				return_count: 20000,
				skip_count: 0,
				suppress_content: false,
				neg_text: "",
				mode: "PAGE",
				treat_like_concept: false,
				selected_database: props?.retainedFilterJobData?.selected_database,
				additional_params: {
					skip_audit: true,
					page_context: params?.[1],
				},
				restrict_file_ids: [fileId],
			}
			dispatch(getPageNumberBasedOnHighlightTextRequest(payload))
		}
	}

	useEffect(() => {
		if (!_.isEmpty(allDocuments)) {
			let fileId
			if (currentDocumentDirection === null) {
				const params = location?.pathname?.split("/")
				fileId = params[params.length - 1]
				let index = allDocuments.findIndex((p) => p.file_id === fileId)
				setCurrentIndex(index)
			} else if (currentDocumentDirection === "previous") {
				setCurrentIndex(allDocuments?.length - 1)
				setCurrentDocumentDirection(null)
				dispatch(resetPageViewerData())
				fileId = allDocuments[9]?.file_id
				history.push({
					pathname: fileId,
					prevPath: location?.state?.prevPath,
					search: window.location.search,
				})
			} else {
				setCurrentIndex(0)
				fileId = allDocuments[0]?.file_id
				history.push({
					pathname: fileId,
					prevPath: location?.state?.prevPath,
					search: window.location.search,
				})
			}

			//TODO: Commenting this code (to be used later - Application reloads multiple times)

			// setTimeout(() => {
			// 	if (props?.retainedFilterJobData?.additional_params?.review_id) {
			// 		dispatch(
			// 			getFileRowClickRequest({
			// 				id: fileId,
			// 				reviewId: props?.retainedFilterJobData?.additional_params?.review_id,
			// 			})
			// 		)
			// 	} else if (props?.retainedFilterJobData?.additional_params?.search_id) {
			// 		dispatch(
			// 			getFileRowClickRequest({
			// 				id: fileId,
			// 				searchId: props?.retainedFilterJobData?.additional_params?.search_id,
			// 			})
			// 		)
			// 	} else {
			// 		dispatch(getFileRowClickRequest(fileId))
			// 	}
			// 	dispatch(
			// 		getFileRequestByPage({
			// 			id: fileId,
			// 			page: 1,
			// 			reviewId: props?.retainedFilterJobData?.additional_params?.review_id,
			// 		})
			// 	)
			// 	dispatch(updateViewerPageNumber(1))
			// 	dispatch(getAuditHistory(fileId))
			// 	dispatch(getAnnotation(fileId))
			// 	dispatch(getReviewBasedOnFileIdRequest(fileId))
			// 	getPageNumberBasedOnHighlightText(fileId)
			// 	// const filterData = { ...highlightFilter }
			// 	// filterData["nativeView"] = !filterData.nativeView
			// 	// dispatch(searchHighlightFilter(filterData))
			// }, 2000)
		}
	}, [allDocuments])

	const getDataBasedOnPsearch = (updatedSkipCount) => {
		dispatch(resetPageViewerData())
		dispatch(resetHighlightFilter())
		document.getElementById("document-list-container")?.scrollIntoView(true)
		const modifiedRetainedFilterJobData = props?.retainedFilterJobData
		const updatedRetainedFilterJobData = { ...modifiedRetainedFilterJobData, skip_count: updatedSkipCount }
		dispatch(updateSkipCount(updatedSkipCount))
		dispatch(
			getViewerAllDocumentsRequest({
				params: updatedRetainedFilterJobData,
				jobIdToRetainData: null,
			})
		)
	}

	const nextClick = () => {
		const params = location?.pathname?.split("/")
		const fileId = params[params.length - 1]
		let index = allDocuments.findIndex((p) => p.file_id === fileId)
		let nextFileId = allDocuments[index + 1]?.file_id
		let isNativePdf = checkToShowNativeFormat(allDocuments[index + 1]?.metadata)
		if (index + 1 >= allDocuments?.length) {
			dispatch(resetPageViewerData())
			getNextPageDetails()
		} else {
			setCurrentIndex(index + 1)
			history.push({
				pathname: nextFileId,
				prevPath: location?.state?.prevPath,
				search: window.location.search,
			})
			dispatch(resetPageViewerData())
			if (props?.retainedFilterJobData?.additional_params?.review_id) {
				dispatch(getFileRowClickRequest({ id: nextFileId, reviewId: props?.retainedFilterJobData?.additional_params?.review_id }))
			} else if (props?.retainedFilterJobData?.additional_params?.search_id) {
				dispatch(getFileRowClickRequest({ id: nextFileId, searchId: props?.retainedFilterJobData?.additional_params?.search_id }))
			} else {
				dispatch(getFileRowClickRequest(nextFileId))
			}
			dispatch(
				getFileRequestByPage({ id: nextFileId, page: 1, reviewId: props?.retainedFilterJobData?.additional_params?.review_id })
			)
			dispatch(updateViewerPageNumber(1))
			dispatch(getAuditHistory(nextFileId))
			dispatch(getAnnotation(nextFileId, isNativePdf))
			dispatch(getReviewBasedOnFileIdRequest(nextFileId))
			getPageNumberBasedOnHighlightText(nextFileId)
			const filterData = { ...highlightFilter }
			filterData["nativeView"] = true
			dispatch(searchHighlightFilter(filterData))
		}
	}

	const previousClick = () => {
		const params = location?.pathname?.split("/")
		const fileId = params[params.length - 1]
		let index = allDocuments.findIndex((p) => p.file_id === fileId)
		let nextFileId = allDocuments[index - 1]?.file_id
		let isNativePdf = checkToShowNativeFormat(allDocuments[index - 1]?.metadata)
		if (index === 0) {
			dispatch(resetPageViewerData())
			getPreviousPageDetails()
		} else {
			setCurrentIndex(index - 1)
			history.push({
				pathname: nextFileId,
				prevPath: location?.state?.prevPath,
				search: window.location.search,
			})
			dispatch(resetPageViewerData())
			if (props?.retainedFilterJobData?.additional_params?.review_id) {
				dispatch(getFileRowClickRequest({ id: nextFileId, reviewId: props?.retainedFilterJobData?.additional_params?.review_id }))
			} else if (props?.retainedFilterJobData?.additional_params?.search_id) {
				dispatch(getFileRowClickRequest({ id: nextFileId, searchId: props?.retainedFilterJobData?.additional_params?.search_id }))
			} else {
				dispatch(getFileRowClickRequest(nextFileId))
			}
			dispatch(
				getFileRequestByPage({ id: nextFileId, page: 1, reviewId: props?.retainedFilterJobData?.additional_params?.review_id })
			)
			dispatch(updateViewerPageNumber(1))
			dispatch(getAuditHistory(nextFileId))
			dispatch(getAnnotation(nextFileId, isNativePdf))
			dispatch(getReviewBasedOnFileIdRequest(nextFileId))
			getPageNumberBasedOnHighlightText(nextFileId)
			const chatPayload = {
				file_ids: [nextFileId],
			}
			if (aiEnabled) {
				dispatch(getChat(chatPayload))
			}
			dispatch(updateCurrentSession(0))
			const filterData = { ...highlightFilter }
			filterData["nativeView"] = true
			dispatch(searchHighlightFilter(filterData))
		}
	}

	const getNextPageDetails = () => {
		if (skipCount + parseInt(props?.retainedFilterJobData?.return_count) < allDocumentsCount) {
			setCurrentDocumentDirection("next")
			getDataBasedOnPsearch(skipCount + parseInt(props?.retainedFilterJobData?.return_count))
			dispatch(updateViewerPageNumber(1))
			if (!_.isEmpty(props?.retainedFilterJobData?.categories)) {
				dispatch(getConceptBasedOnId(props?.retainedFilterJobData?.categories))
			}
			if (!_.isEmpty(props?.retainedFilterJobData?.text)) {
				const filterData = { ...highlightFilter }
				filterData.loadedConcept = [...filterData?.loadedConcept, ...props?.retainedFilterJobData?.text]
				dispatch(searchHighlightFilter(filterData))
			}
		}
	}

	const getPreviousPageDetails = () => {
		if (skipCount !== 0) {
			setCurrentDocumentDirection("previous")
			getDataBasedOnPsearch(skipCount - parseInt(props?.retainedFilterJobData?.return_count))
			dispatch(updateViewerPageNumber(1))
			if (!_.isEmpty(props?.retainedFilterJobData?.categories)) {
				dispatch(getConceptBasedOnId(props?.retainedFilterJobData?.categories))
			}
			if (!_.isEmpty(props?.retainedFilterJobData?.text)) {
				const filterData = { ...highlightFilter }
				filterData.loadedConcept = [...filterData?.loadedConcept, ...props?.retainedFilterJobData?.text]
				dispatch(searchHighlightFilter(filterData))
			}
		}
	}

	const disablePreviousClick = () => {
		if (skipCount === 0) {
			if (currentIndex === 0) {
				return false
			}
		}
		return true
	}

	const disableNextClick = () => {
		if (skipCount + parseInt(props?.retainedFilterJobData?.return_count) > allDocumentsCount) {
			if (currentIndex === allDocuments.length - 1) {
				return false
			}
		}
		return true
	}

	return (
		<>
			{!allDocumentsLoading && (
				<Box className={classes.pagination}>
					<Box style={{ display: "flex", justifyContent: "center" }}>
						<Box
							onClick={() => {
								disablePreviousClick() ? previousClick() : undefined
							}}
							style={{
								display: "flex",
								cursor: "pointer",
								opacity: disablePreviousClick() ? 1 : 0.5,
								transform: "rotate(-90deg)",
							}}
						>
							<PaginationUpSVG />
						</Box>
						<Box
							onClick={() => {
								disableNextClick() ? nextClick() : undefined
							}}
							style={{
								padding: "0px 10px",
								display: "flex",
								cursor: "pointer",
								transform: "rotate(-90deg)",
								opacity: disableNextClick() ? 1 : 0.5,
							}}
						>
							<PaginationDownSVG />
						</Box>
					</Box>
				</Box>
			)}
		</>
	)
}

export default ViewerDocumentNavigation
